import JwtDecode from 'jwt-decode'

export default class User {
  static from (token) {
    try {
      let obj = JwtDecode(token)
      return new User(obj, token)
    } catch (_) {
      return null
    }
  }

  constructor ({ id, name, picture, exp }, token) {
    this.id = id
    this.name = name
    this.picture = picture
    this.token = token
    this.expiry = exp
  }

  get isExpired () {
    var now = new Date()
    return (now.getTime() / 1000.0) > this.expiry
  }
}
